import {aesDecrypt} from "./EncodeDecodeMethod";
import {PostToJava} from "./ApiMethod";
import {Arguments} from "./Arguments";
import {message} from "antd";

export default function LoginMethod(item, baseUrl) {
    // 向用户中心接口发送 post 请求，验证用户名和密码是否正确
    const loginApi = Arguments.host + "/society_organization/login/author!login.do";
    const loginInfo = {username: item.userName, password: aesDecrypt(item.password)}
    PostToJava(loginApi, loginInfo).then(res => {
        if (res?.data.code === 1) {
            const userInfo = res.data.result;
            const newTab = window.open(Arguments.reactUrl + baseUrl + '-admin', '_blank')
            if (newTab) {
                // 方便接口 token 校验以及页面显示用户名等信息
                sessionStorage.setItem("userToken", userInfo.token);
                // 方便登录页右上角显示用户名以及修改密码时填入默认的用户名
                sessionStorage.setItem("ghost", item.nickname);
                // 方便用户修改密码时使用，对密码使用对称加密保存
                sessionStorage.setItem("shadow", item.password);
                // 将登录用户的 organization_id 和 role 并存储在 sessionStorage 中
                sessionStorage.setItem("coffee", (parseInt(item.organizationId) * 20).toString())
                sessionStorage.setItem("rain", item.role)
                setTimeout(() => {
                    window.open(Arguments.reactUrl + baseUrl, '_self')
                }, 300)
            }
        } else {
            message.error("登录失败");
        }
    })
}